import script from "./InfoPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoPanel.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__